module.exports = __webpack_public_path__ + "static/media/partner-image-06.0bde947e.svg";